import { BrowserRouter, useLocation } from "react-router-dom";
import routes from "./constants/routes";

import Header from "./components/Header/Header";
import AppRoutes from "./Routes";

const AppContent = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === routes.login.root;

  return (
    <div>
      {!isLoginPage && <Header />}
      <AppRoutes />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
